// Maps a customer design upload failure to the message a shopper can act on.
export type DesignUploadErrorKey =
  | "customerDesign.error"
  | "customerDesign.errorTooLarge"
  | "customerDesign.errorType"
  | "customerDesign.errorContent"
  | "customerDesign.errorMalware"
  | "customerDesign.errorBusy";

const keysByCode: Record<string, DesignUploadErrorKey> = {
  BODY_TOO_LARGE: "customerDesign.errorTooLarge",
  CUSTOMER_DESIGN_FILE_TOO_LARGE: "customerDesign.errorTooLarge",
  CUSTOMER_DESIGN_TYPE_REJECTED: "customerDesign.errorType",
  CUSTOMER_DESIGN_FILENAME_INVALID: "customerDesign.errorType",
  CUSTOMER_DESIGN_EMPTY_FILE: "customerDesign.errorContent",
  CUSTOMER_DESIGN_CONTENT_REJECTED: "customerDesign.errorContent",
  CUSTOMER_DESIGN_ACTIVE_CONTENT_REJECTED: "customerDesign.errorContent",
  CUSTOMER_DESIGN_MALWARE_SUSPECTED: "customerDesign.errorMalware",
  CUSTOMER_DESIGN_UPLOAD_BUSY: "customerDesign.errorBusy",
  SERVICE_UNAVAILABLE: "customerDesign.errorBusy",
};

export const designUploadErrorKey = (error: unknown): DesignUploadErrorKey =>
  (error instanceof Error ? keysByCode[error.message] : undefined) ??
  "customerDesign.error";
